// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CHANGED_AVATAR = "si zmenila profilov\u00fa fotku";
export const CHILD_ADDED = "pridala dc\u00e9ru do svojho profilu";
export const CHILD_ADDED_DAUGHTER = "pridala dc\u00e9ru do svojho profilu";
export const CHILD_ADDED_SON = "pridala syna do svojho profilu";
export const CHILD_EDITED_DAUGHTER = "zmenila fotku svojej dc\u00e9ry";
export const CHILD_EDITED_SON = "zmenila fotku svojho syna";
export const counter_NEW_PHOTOS = ["%(counter)s nov\u00e1 fotka", "%(counter)s nov\u00e9 fotky", "%(counter)s nov\u00fdch fotiek"];
export const counter_PHOTOS = ["%(counter)s fotka", "%(counter)s fotky", "%(counter)s fotiek"];
export const EXPERIENCE_ADDED = "pridala hodnotenie";
export const FORUM_THREAD_ADDED = "zalo\u017eila diskusiu";
export const GROUP_MODERATOR_SHORT = "Moder\u00e1tor";
export const NEW_POST = "Nov\u00fd";
export const NUMBER_OF_VIEWS_count = "\u010c\u00edtan\u00e9 %(count)sx";
export const number_MINUTES = ["%(number)s min\u00fata", "%(number)s min\u00faty", "%(number)s min\u00fat"];
export const PB_POST_HAS_BEEN_EDITED = "Spr\u00e1va bola zmenen\u00e1";
export const PB_SHARED_A_POST = "zdie\u013eala pr\u00edspevok";
export const POST_REMOVE_COMPLAINTS = "Zru\u0161 nahl\u00e1senie pr\u00edspevku";
export const READ_WHOLE_ARTICLE = "\u010c\u00edtaj cel\u00fd \u010dl\u00e1nok";
export const RECIPE_ADDED = "pridala recept";
export const RECIPE_CREATE_FROM_POST_HINT = "Preme\u0148 na recept \u2192 kraj\u0161\u00ed dizajn, suroviny, postup";
export const SHOW = "Zobraz";
export const SHOW_FULL_MESSAGE = "Zobraz cel\u00fa spr\u00e1vu";
